import { ChangeEvent, forwardRef } from 'react';

import { IClassname } from '@/lib/shared/model/classname';

import cn from 'clsx';

import styles from './styles.module.scss';

export interface CounterProps extends IClassname {
  value: number | null;
  onChange: (value: number | null) => void;
  minValue?: number;
  maxValue?: number;
}
const Counter = forwardRef<HTMLDivElement, CounterProps>(
  ({ value, onChange, className, minValue = 0, maxValue = 10 }, ref) => {
    const onChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
      onChange(Number(event.target.value));
    };

    const onBlur = () => {
      if (value === null) {
        onChange(0);
      } else if (value > maxValue) {
        onChange(maxValue);
      } else if (value < minValue) {
        onChange(minValue);
      }
    };

    return (
      <div ref={ref} className={cn(className, styles.counter)}>
        <div
          onClick={() => value !== minValue && onChange((value || 0) - 1)}
          className={cn(styles.control, value === minValue && styles.disabled)}
        >
          -
        </div>
        <input
          pattern="\d*"
          className={styles.input}
          value={String(value)}
          maxLength={2}
          onChange={onChangeInput}
          onBlur={onBlur}
        />
        <div
          onClick={() => value !== maxValue && onChange((value || 0) + 1)}
          className={cn(styles.control, value === maxValue && styles.disabled)}
        >
          +
        </div>
      </div>
    );
  }
);

Counter.displayName = 'Counter';

export default Counter;
